<template>
  <el-card>
    <el-form-item>
      <span style="margin-bottom: 8px">二维码标签 ：</span>
<!--      <el-button style="margin-bottom: 8px" @click="printPreview1" :loading="loading">预览80*80</el-button>-->
      <el-button style="margin-bottom: 8px;background-color: yellow" @click="printPreview2" :loading="loading">预览90*80</el-button>
<!--      <el-button style="margin-bottom: 8px" @click="print1" :loading="loading">打印80*80</el-button>-->
      <el-button style="margin-bottom: 8px" @click="print2" type="primary" :loading="loading">打印90*80</el-button>
      <KfMessage ref="commitMessage"></KfMessage>
    </el-form-item>
    <el-form-item v-if="this.view1">
      <div id="divPrint">
        <img class="preview-img" :src="imageBase64" v-for="(imageBase64,index) in imageBase64List" :key="index"
             :style="'width:' + imageWidth1 + 'px; height:' + imageHeight1 + 'px;'" v-if="imageBase64.length > 0">
      </div>
    </el-form-item>

    <el-form-item v-if="this.view2">
      <div id="divPrint">
        <img class="preview-img" :src="imageBase64" v-for="(imageBase64,index) in imageBase64List" :key="index"
             :style="'width:' + imageWidth2 + 'px; height:' + imageHeight2 + 'px;'" v-if="imageBase64.length > 0">
      </div>
    </el-form-item>
  </el-card>
</template>

<script>
export default {
  name: "EqDeviceListZhiZaoPrint",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      //num: 0,
      imageBase64: '',
      imageHeight1: 270,
      imageWidth1: 270,
      imageHeight2: 270,
      imageWidth2: 305,
      view1: false,
      view2: false,
      imageBase64List: [],
      loading: false,
      printDto: {},
    }
  },
  methods: {

    async printPreview1() {
      this.loading = true;
      this.printImages = []
      await this.$http('eqDeviceZhiZaoService.getDeviceTmplLabel1',this.formData, false).then(data => {
        this.loading = false;
        this.printDtoList = data

        for (let i = 0; i < this.printDtoList.length; i++) {
          let printDto = JSON.parse(JSON.stringify(this.printDtoList[i]))
          if (printDto.image_base64.length > 0) {
            printDto.image_base64 = "data:image/jpeg;base64," + printDto.image_base64;
          }
          this.printImages.push(printDto)
        }
        this.view1 = true
        this.view2 = false
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },

    async print1() {
      await this.printPreview1();
      this.loading = false;
      // this.printDiv()
      // 调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      for (let i = 0; i < this.printDtoList.length; i++) {
        console.log(this.printDtoList[i])
        this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDtoList[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },


    async printPreview2() {
      this.loading = true;
      this.printImages = []

      await this.$http('eqDeviceZhiZaoService.getDeviceTmplLabel2',this.formData, false).then(data => {
        this.loading = false;
        this.printDtoList = data


        for (let i = 0; i < this.printDtoList.length; i++) {
          let printDto = JSON.parse(JSON.stringify(this.printDtoList[i]))
          if (printDto.image_base64.length > 0) {
            printDto.image_base64 = "data:image/jpeg;base64," + printDto.image_base64;
          }
          this.printImages.push(printDto)
        }
        this.view1 = true
        this.view2 = false
      }, errMsg => {
        this.loading = false;
        this.$refs.commitMessage.showError(`生成打印图像失败，${errMsg}`);
      })
    },


    async print2() {
      await this.printPreview2();
      this.loading = false;
      // this.printDiv()
      // 调用本地打印服务器
      // var printParams = {printer_name: this.printDto.printerName, zpl: this.printDto.zpl};
      for (let i = 0; i < this.printDtoList.length; i++) {
        console.log(this.printDtoList[i])
        this.$axios.post(process.env.VUE_APP_PRINT_URL, this.printDtoList[i]).then(response => {
          this.loading = false;
          let res = response.data
          console.log(res)
        }, error => {
          this.loading = false;
          console.log(`提交打印失败，${error.message}`)
          this.$message.error('连接打印机失败，请检查打印机状态。');
        })
      }
    },

    printDiv() {
      //打印div
      //打开一个新窗口newWindow
      var newWindow = window.open("打印窗口", "_blank");
      //要打印的div的内容
      var docStr = document.getElementById("divPrint").innerHTML;
      //打印内容写入newWindow文档
      newWindow.document.write(docStr);
      //关闭文档
      newWindow.document.close();

      //调用打印机
      setTimeout(() => {
        newWindow.print();
        newWindow.close();
      }, 50);

      return false;
    }

  }
}
</script>

<style scoped>
.preview-img {
  width: 500px;
  height: 350px;
  border: solid 1px #a1a1a1;
}
</style>